export const parseStageNames = raw =>
  String(raw || '')
    .split(/[,\n]/)
    .map(name => name.trim())
    .filter(Boolean);

export const buildBoardPayload = ({ name, template, stages }) => {
  const boardName = name.trim();

  if (template) return { name: boardName, template };

  return { name: boardName, stage_names: parseStageNames(stages) };
};

export const isBoardFormValid = ({ name, template, stages }) =>
  Boolean(name.trim()) &&
  (Boolean(template) || parseStageNames(stages).length > 0);
